var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/core-js/object/define-property", "@babel/runtime-corejs2/core-js/object/define-properties", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor", "@babel/runtime-corejs2/core-js/object/get-own-property-symbols", "@babel/runtime-corejs2/core-js/object/keys", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/defineProperty", "@babel/runtime-corejs2/helpers/objectWithoutProperties", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "react", "prop-types"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/core-js/object/define-property"), require("@babel/runtime-corejs2/core-js/object/define-properties"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"), require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"), require("@babel/runtime-corejs2/core-js/object/keys"), require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("@babel/runtime-corejs2/helpers/objectWithoutProperties"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("react"), require("prop-types"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.defineProperties, global.getOwnPropertyDescriptors, global.getOwnPropertyDescriptor, global.getOwnPropertySymbols, global.keys, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.defineProperty, global.objectWithoutProperties, global.classCallCheck, global.createClass, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.react, global.propTypes);
    global.RenderLink = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _defineProperties, _getOwnPropertyDescriptors, _getOwnPropertyDescriptor, _getOwnPropertySymbols, _keys, _es6Regexp, _es6Date, _es6Object, _construct, _defineProperty3, _objectWithoutProperties2, _classCallCheck2, _createClass2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _react, _propTypes) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty2(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _defineProperties = _interopRequireDefault(_defineProperties);
  _getOwnPropertyDescriptors = _interopRequireDefault(_getOwnPropertyDescriptors);
  _getOwnPropertyDescriptor = _interopRequireDefault(_getOwnPropertyDescriptor);
  _getOwnPropertySymbols = _interopRequireDefault(_getOwnPropertySymbols);
  _keys = _interopRequireDefault(_keys);
  _construct = _interopRequireDefault(_construct);
  _defineProperty3 = _interopRequireDefault(_defineProperty3);
  _objectWithoutProperties2 = _interopRequireDefault(_objectWithoutProperties2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);

  function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var RenderLink = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(RenderLink, _PureComponent);

    var _super = _createSuper(RenderLink);

    function RenderLink() {
      (0, _classCallCheck2.default)(this, RenderLink);
      return _super.apply(this, arguments);
    }

    (0, _createClass2.default)(RenderLink, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            _this$props$renderLin = _this$props.renderLink,
            renderLink = _this$props$renderLin === void 0 ? null : _this$props$renderLin,
            className = _this$props.className,
            tabIndex = _this$props.tabIndex,
            href = _this$props.href,
            children = _this$props.children,
            mouseFocus = _this$props.mouseFocus,
            rest = (0, _objectWithoutProperties2.default)(_this$props, ["renderLink", "className", "tabIndex", "href", "children", "mouseFocus"]);

        if (renderLink === null) {
          return /*#__PURE__*/_react.default.createElement('a', _objectSpread({
            href: href,
            tabIndex: tabIndex,
            className: className
          }, rest), children);
        }

        return renderLink(_objectSpread({
          href: href,
          tabIndex: tabIndex,
          className: className,
          children: children
        }, rest));
      }
    }]);
    return RenderLink;
  }(_react.PureComponent);

  RenderLink.propTypes = {
    className: _propTypes.default.string.isRequired,
    children: _propTypes.default.node,
    renderLink: _propTypes.default.func,
    tabIndex: _propTypes.default.number,
    href: _propTypes.default.string
  };
  var _default = RenderLink;
  _exports.default = _default;
});